// extracted by mini-css-extract-plugin
module.exports = {"app":"express_app__3pTyZ"};